import React from 'react'
import styled from 'styled-components'

import { VARIANT_DANGER } from '../../constants/variants'
import { Body } from '../common/Typography'
import { FormError } from '../common/FormError'

export const CheckboxField = ({
  input, label, meta = {},
}) => (
  <>
    <CheckboxWrapper>
      <CustomCheckbox type="checkbox" checked={input.checked} onChange={input.onChange} />
      <Body
        tradId={label}
        variant={(meta.error || (!meta.dirtySinceLastSubmit && meta.submitError)) ? VARIANT_DANGER : ''}
      />
    </CheckboxWrapper>
    <FormError error={meta.touched && (meta.error || (!meta.dirtySinceLastSubmit && meta.submitError))} />
  </>
)

const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`

const CustomCheckbox = styled.input`
  margin-right: 10px;
`
